import React from 'react'
import styled from 'styled-components'
import { colors } from '../styles/vars'

const StyledCircle = styled.div`
width:240px;
height:240px;
`
const Svg = styled.svg`

`
const CircleBg = styled.path`
fill: none;
`
const Circle = styled.path`
stroke: ${colors.white};
fill: none;
stroke-width: 2.8;
// transition:stroke-dasharray .1s;
`
const SvgCircle = (props) => {
    return (
        <StyledCircle>
    <Svg viewBox="0 0 36 36">
      <CircleBg
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <Circle
        strokeDasharray={`${props.percentage}, 100`}
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
    </Svg>
        </StyledCircle>
    );
}

export default SvgCircle;


// WEBPACK FOOTER //
// ./src/components/SvgCircle.jsx